<template>
  <div>
    <!-- 使用 el-tooltip 包裹内容 -->
    <el-tooltip
      :disabled="!showTooltip"
      :content="content"
      placement="bottom"
      effect="light"
    >
      <div
        ref="contentBox"
        class="multi-line-ellipsis"
        @mouseover="checkOverflow"
      >
        <slot></slot>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showTooltip: false // 控制是否显示 Tooltip
    };
  },
  methods: {
    // 检查内容是否溢出
    checkOverflow() {
      const el = this.$refs.contentBox;
      if (el) {
        // 比较实际高度和两行高度
        this.showTooltip = el.scrollHeight > el.clientHeight;
      }
    }
  }
};
</script>

<style scoped>
.multi-line-ellipsis {
  vertical-align: middle;
  /* 多行省略样式 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制两行 */
  overflow: hidden;
  text-overflow: ellipsis;

  /* 以下样式确保布局正确 */
  line-height: 1.5; /* 行高 */
  max-height: 3em; /* 2行 x 1.5行高 = 3em */
  word-break: break-all; /* 处理长单词换行 */

  /* 可选：添加过渡效果 */
  transition: all 0.3s;
}
</style>